import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value"]

import {
  ref,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberField',
  props: {
  value: [String, Number],
  name: {
    type: String,
    required: false,
  },
},
  emits: ['input'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const root = ref();

const emitInput = () => {
  if (root.value) {
    emit('input', root.value.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    ref_key: "root",
    ref: root,
    class: "base-input__input",
    type: "number",
    name: __props.name,
    value: __props.value,
    onInput: emitInput
  }, null, 40, _hoisted_1))
}
}

})